module.exports = __webpack_public_path__ + "staticcomp/img/share.c8e0997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/6/share.jpg
// module id = s6OZ
// module chunks = 39